import type { Family } from '@tonist/shared';

export const FAMILY_LABEL: Record<Family, string> = { white: 'White · Vairocana', blue: 'Blue · Akshobhya', yellow: 'Yellow · Ratnasambhava', red: 'Red · Amitabha', green: 'Green · Amoghasiddhi' };

export function FamilyDot({ family, title }: { family: Family; title?: string }) {
  return <span className={`dot dot--${family}`} title={title ?? FAMILY_LABEL[family]} aria-hidden="true" />;
}
